export enum sortTypesEnum {
    none = 'none',
    qty = 'inventory',
    price = 'price',
    justlaunched = 'justlaunched',
    pricedrop = 'pricedrop',
    purchasedate = 'purchasedate',
    model= 'description'
}
